
export default function Title(props) {
  return (
    <div>
        <h1 style={{backgroundColor:"orange",borderBottom:"5px solid red"}}> {props.mainT}</h1>
   
    </div>
  )
}
